import React, { useEffect } from "react";

import {
  FaSave,
  FaTimes,
} from "react-icons/fa";

export default function EditorDrawerShell({
  open,
  eyebrow,
  title,
  description,
  icon,
  saving,
  submitLabel = "Enregistrer",
  onClose,
  onSubmit,
  children,
}) {
  useEffect(() => {
    if (!open) {
      return;
    }

    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (
        event.key === "Escape" &&
        !saving
      ) {
        onClose?.();
      }
    };

    document.addEventListener(
      "keydown",
      handleEscape
    );

    return () => {
      document.body.style.overflow =
        previousOverflow;

      document.removeEventListener(
        "keydown",
        handleEscape
      );
    };
  }, [open, saving, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1350]">
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm"
        onClick={
          saving ? undefined : onClose
        }
        aria-label="Fermer"
      />

      <aside className="absolute inset-y-0 right-0 flex w-full max-w-4xl flex-col border-l border-slate-200 bg-white shadow-[-35px_0_100px_-40px_rgba(0,0,0,0.65)] dark:border-slate-800 dark:bg-slate-900">
        <header className="relative overflow-hidden bg-slate-950 text-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(99,102,241,0.38),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(217,70,239,0.28),transparent_32%)]" />

          <div className="relative flex items-start justify-between gap-4 p-5 sm:p-6">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-white/75">
                {icon}
                {eyebrow}
              </div>

              <h2 className="mt-3 text-2xl font-semibold">
                {title}
              </h2>

              {description ? (
                <p className="mt-1 max-w-2xl text-sm leading-6 text-white/70">
                  {description}
                </p>
              ) : null}
            </div>

            <button
              type="button"
              disabled={saving}
              onClick={onClose}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-white/15 bg-white/10 transition hover:bg-white/20 disabled:opacity-50"
            >
              <FaTimes />
            </button>
          </div>
        </header>

        <form
          onSubmit={onSubmit}
          className="flex min-h-0 flex-1 flex-col"
        >
          <div className="flex-1 overflow-y-auto bg-slate-50 p-4 dark:bg-slate-950/50 sm:p-6">
            {children}
          </div>

          <footer className="border-t border-slate-200 bg-white/95 px-4 py-4 backdrop-blur dark:border-slate-800 dark:bg-slate-900/95 sm:px-6">
            <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
              <button
                type="button"
                disabled={saving}
                onClick={onClose}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
              >
                <FaTimes />
                Annuler
              </button>

              <button
                type="submit"
                disabled={saving}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 px-5 py-2.5 text-sm font-medium text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <FaSave />

                {saving
                  ? "Enregistrement..."
                  : submitLabel}
              </button>
            </div>
          </footer>
        </form>
      </aside>
    </div>
  );
}